<template>
  <v-card class="mx-auto" v-if="page">
    <v-img :src="image" height="200px"></v-img>
    <router-link :to="'/b/' + page.nameLink">
      <v-card-title>
        {{
          page.sections != null &&
          page.sections[0] != null &&
          page.sections[0].blocks != null &&
          page.sections[0].blocks[0] != null
            ? page.sections[0].blocks[0].title
            : ""
        }}
      </v-card-title>
    </router-link>

    <v-card-subtitle>
      <p
        v-html="
          page.sections != null &&
          page.sections[0] != null &&
          page.sections[0].blocks != null &&
          page.sections[0].blocks[0] != null
            ? page.sections[0].blocks[0].content
            : ''
        "
      ></p>
    </v-card-subtitle>

    <!-- <v-card-actions>
      <v-btn color="orange lighten-2" text> Explore </v-btn>

      <v-spacer></v-spacer>

      <v-btn icon @click="show = !show">
        <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>

        <v-card-text>
          I'm a thing. But, like most politicians, he promised more than he
          could deliver. You won't have time for sleeping, soldier, not with all
          the bed making you'll be doing. Then we'll go with that data file!
          Hey, you add a one and two zeros to that or we walk! You're going to
          do his laundry? I've got to find a way to escape.
        </v-card-text>
      </div>
    </v-expand-transition> -->
  </v-card>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "SingleContent",
  components: {},
  props: {
    content: {
      default: null,
    },
  },
})
export default class SingleContent extends Vue {
  page = {};
  image = null;
  htmlSubstring(s, n) {
    let m;
    const r = /<([^>\s]*)[^>]*>/g;
    const stack = [];
    let lasti = 0;
    let result = "";

    //for each tag, while we don't have enough characters
    while ((m = r.exec(s)) && n) {
      //get the text substring between the last tag and this one
      const temp = s.substring(lasti, m.index).substr(0, n);
      //append to the result and count the number of characters added
      result += temp;
      n -= temp.length;
      lasti = r.lastIndex;

      if (n) {
        result += m[0];
        if (m[1].indexOf("/") === 0) {
          //if this is a closing tag, than pop the stack (does not account for bad html)
          stack.pop();
        } else if (m[1].lastIndexOf("/") !== m[1].length - 1) {
          //if this is not a self closing tag than push it in the stack
          stack.push(m[1]);
        }
      }
    }

    //add the remainder of the string, if needed (there are no more tags in here)
    result += s.substr(lasti, n);

    //fix the unclosed tags
    while (stack.length) {
      result += "</" + stack.pop() + ">";
    }
    return result;
  }

  htmlToPlaintext(text) {
    return text ? String(text).replace(/<[^>]+>/gm, "") : "";
  }

  processData(page) {
    if (page) {
      for (let j = 0; j < page.sections.length; j++) {
        if (page.sections[j] && page.sections[j].blocks) {
          for (let k = 0; k < page.sections[j].blocks.length; k++) {
            if (page.sections[j].blocks[k]) {
              if (page.sections[j].blocks[k].title) {
                let tit = this.htmlSubstring(
                  page.sections[j].blocks[k].title,
                  30
                );
                if (
                  page.sections[j].blocks[k].title &&
                  page.sections[j].blocks[k].title.length > 30
                ) {
                  tit = tit + "...";
                }
                page.sections[j].blocks[k].title = tit;
              }
              if (page.sections[j].blocks[k].content) {
                let cont = this.htmlSubstring(
                  page.sections[j].blocks[k].content,
                  130
                );
                if (cont) {
                  cont = cont.replaceAll("<br>", "");
                  cont = cont.replaceAll("</br>", "");
                }
                page.sections[j].blocks[k].content = this.htmlToPlaintext(cont);
              }
              if (page.sections[j].blocks[k].images && !this.image) {
                for (
                  let l = 0;
                  l < page.sections[j].blocks[k].images.length;
                  l++
                ) {
                  if (
                    page.sections[j].blocks[k].images[l] &&
                    page.sections[j].blocks[k].images[l].url
                  ) {
                    this.image = page.sections[j].blocks[k].images[l].url;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  async mounted() {
    const page = this.content;
    this.processData(page);
    this.page = page;
  }
}
</script>